/* Do not edit this file to avoid losing your changes when upgrade the theme */
var BT = {
    selectors: {
        sidebar: {
            btn: ".bt-sidebar-btn",
            box: ".bt-sidebar",
            closeBtnCanvas: ".bt-sidebar__close",
            closeSidebarBtn: ".close-menu-btn",
            openClass: "open-sidebar-canvas",
            overlayClass: "overlay--sidebar"
        },
        overlay: ".overlay",
        showOverlayClass: "show-overlay",
        slider: {
            useTouchMobile: "use-touch-mobile",
            default: ".use-slider",
            overFloatClasses: "ov-slider-tb ov-slider-mb hide-in-loading"
        },
        desktopNav: {
            topItem: ".nav__item",
            parentItem: ".nav__item--parent",
            dropdown: ".nav__item__dropdown",
            parentNav: ".header__wrap"
        },
        verticalNav: {
            topItem: ".nav__item--ver",
            parentItem: ".nav__item--parent",
            dropdown: ".nav__item__dropdown",
            parentNav: ".main-nav--ver"
        },
        dropdown: {
            wrap: ".bt-dropdown",
            trigger: ".bt-dropdown__trigger",
            content: ".bt-dropdown__content"
        },
        productGroup: {
            wrap: ".pg",
            option: ".pg__option",
            swatch: ".pg__option__values",
            optionValue: ".pg__option__value",
            mainImg: ".pg__main-image",
            thumbs: ".pg__thumbs",
            thumbsSmallClass: "pg__thumbs--small",
            thumbsLargeClass: ".pg__thumbs--large",
            thumbsSlider: ".pg__thumbs--slider",
            thumbsSliderVerticalClass: "pg__thumbs--slider-vertical",
            thumb: ".pg__thumb",
            thumbLink: ".pg__thumb__link",
            mains: ".pg__mains",
            mainsSlider: ".pg__mains--slider",
            main: ".pg__main",
            mainLink: ".pg__main__link",
            mainLinkModel: ".pg__main__link--model",
            price: ".product-price",
            cartBtn: ".add-cart-btn",
            cartBtnState: ".add-cart-btn--state",
            variantId: ".variant-id",
            variantTitle: ".pg__variant-title",
            loadingClass: "loading-data",
            groupData: ".group-data",
            reCalcIndexClass: "re-calc-index",
            imgZoom: ".cloudzoom",
            countdown: ".pg__countdown-js",
            syncUrl: ".pg__sync-url",
            labelDeal: ".lb-item--sale",
            labelPercent: ".lb__percent",
            stickySmallPrice: ".sc__small-price",
            singleProgress: ".product-single__progress",
            stockText: ".pg__stock-text",
            stockText1: ".pg__stock-text1",
            stockText2: ".pg__stock-text2",
            stockNumber: ".pg__stock-number--update",
            video: ".pg__video",
            videoYoutube: ".pg__video--youtube",
            videoVimeo: ".pg__video--vimeo",
            sku: ".pg__sku",
            ignoreLightBoxClass: "ignore-lightbox",
            swatchOutStock: "swatch__item--soldout",
            storePickupWrap: ".store-availability-container",
            storePickupInner: ".store-availability-inner",
            storePickupBtn: ".store-availability-information__button",
            storePickupModel: "#storePickupPopup",
            storePickupProductTitle: ".store-availabilities-modal__product-title",
            storePickupVariantTitle: ".store-availabilities-modal__variant-title"
        },
        cart: {
            addBtn: ".add-cart-btn",
            updateBtn: ".update-cart-btn",
            header: ".header__cart",
            headerTriggerDesktop: ".header__cart-trigger-desktop",
            headerTriggerMobile: ".header__cart-trigger-mobile",
            number: ".cart-number",
            total: ".cart-total",
            selectOptionClass: "select-option",
            qtyInput: ".cart__qty-input"
        },
        qtyBox: {
            ctrlBtn: ".qty-box__ctrl",
            decreaseBtnClass: "qty-box__ctrl--descrease",
            increaseBtnClass: "qty-box__ctrl--increase",
            inputSyncClass: "qty-box__input--sync"
        },
        mediaBtn: ".button--media",
        loadingAjaxClass: "loading-ajax",
        workingClass: "working",
        qvBtn: ".button--qv",
        qvPopup: "#quickViewPopup",
        selectOptionBtn: ".button--select-option",
        selectOptionPopup: "#selectOptionPopup",
        compare: {
            popup: "#comparePopup",
            btn: ".button--cp",
            removeBtn: ".button-cp--remove",
            variantId: ".variant-id--compare",
            actionsRow: ".actions-row",
            availabilityRow: ".availability-row",
            bestPriceBadge: ".compare-popup__badge",
            headerLink: ".header__link--compare",
            number: ".compare-number"
        },
        wishlist: {
            popup: "#wishlistPopup",
            btn: ".button--wl",
            btnWithText: ".button--wl-text",
            btnText: ".wishlist-text",
            removeBtn: ".button-wl--remove",
            headerLink: ".header__link--wishlist",
            number: ".wishlist-number"
        },
        waitingData: ".waiting-data",
        waitingTabData: ".waiting-tab-data",
        waitingScrollData: ".waiting-scroll-data",
        loadMoreBtn: ".button--more",
        loadingFull: ".loading-full",
        cartMessage: ".cart-message",
        cartModal: {
            wrap: "#cartModal",
            productImage: ".cart-response__image",
            productName: ".cart-response__name",
            variantTitle: ".cart-response__meta-variant-title-wrap",
            variantProp: ".cart-response__meta-propeties",
            price: ".cart-response__price .product-price__price",
            linePrice: ".cart-response__line-price .product-price__price",
            qty: ".cart-response__qty",
            freeShippingText: ".cart-response__free-shipping__text",
            freeShippingProgressBar: ".progress-bar--popup-cart"
        },
        notify: ".notify",
        notifyClassTypes: "alert-success alert-danger",
        floatField: ".field--float-label",
        floatFieldFirstFocus: ".first-focus",
        rp: {
            wrap: ".rp",
            item: ".rp__item",
            minuteNumber: ".rp__minute-number",
            closeBtn: ".rp__close"
        },
        newsPopup: {
            id: "#newsletterPopup",
            checkbox: "#newsPopupHide"
        },
        newsTerms: {
            form: ".newsletter-form",
            input: ".news-terms-input",
            error: ".news-terms-error"
        },
        promo: {
            wrap: ".promo",
            closeBtn: ".promo__close",
            list: ".promo__list"
        },
        upsell: {
            wrap: ".upsell-ele",
            list: ".upsell-list"
        },
        related: {
            wrap: ".related-ele",
            list: ".related-list"
        },
        loadingNotFull: ".loading-not-full",
        infiniteScroll: {
            button: ".infinite-scroll",
            wait: ".wait-infinite-scroll"
        },
        cartTerms: {
            wrap: ".cart-terms",
            popup: "#termsPopup",
            checkbox: ".terms-check",
            label: ".cart-terms__label",
            checkoutBtn: ".checkout-btn",
            paymentBtn: ".shopify-payment-button,.additional-checkout-buttons"
        },
        popupVideo: {
            btn: ".video-thumbnail",
            youtubeBtn: ".js-modal-btn--youtube",
            vimeoBtn: ".js-modal-btn--vimeo"
        },
        searchFull: {
            wrap: ".search-full",
            trigger: ".search-full-trigger",
            content: ".search-full__content",
            input: ".search-full__input",
            inputSync: ".search-full__input-sync",
            loading: ".search-full__loading",
            close: ".search-full__close-js",
            tabTitle: ".search-full__tab-title",
            tabList: ".search-full__tab-list",
            tabContent: ".search-full__content__tab",
            result: ".search-full__result",
            loadedClass: "loaded",
            suggestProducts: ".search-full__suggest-products"
        },
        ringClass: "ring-animation",
        ajaxSnippet: ".load-ajax-snippet"
    },
    options: {
        dropdown: {
            duration: 150,
            overlaySuffixEvent: "bt-dropdown",
            noOverLayClass: "nooverlay"
        },
        sidebar: {
            duration: 300,
            openEvent: "click",
            closeEvent: "click",
            overlaySuffixEvent: "bt-sidebar"
        },
        slider: {
            slidesToShow: 4,
            slidesToScroll: 1,
            dots: !1,
            focusOnSelect: !1,
            infinite: !1,
            swipe: !0,
            swipeToSlide: !0,
            rtl: rtl,
            nextArrow: '<button aria-label="button" class="slick-next lh1"><span></span></button>',
            prevArrow: '<button aria-label="button" class="slick-prev lh1"><span></span></button>',
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            }]
        },
        productGroup: {
            smallSlider: {
                slidesToShow: 5,
                slidesToScroll: 1,
                swipeToSlide: !0,
                infinite: !1,
                focusOnSelect: !0,
                centerMode: !1,
                rtl: rtl,
                nextArrow: '<button aria-label="button" class="slick-next lh1 slick-box"><span></span></button>',
                prevArrow: '<button aria-label="button" class="slick-prev lh1 slick-box"><span></span></button>',
                responsive: [{
                    breakpoint: 992,
                    settings: {
                        vertical: !1,
                        verticalSwiping: !1,
                        slidesToShow: 5
                    }
                }]
            },
            mainSlider: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: !0,
                fade: !1,
                infinite: !1,
                swipeToSlide: !0,
                dots: !1,
                adaptiveHeight: !0,
                lazyLoad: "ondemand",
                rtl: rtl,
                nextArrow: '<button aria-label="button" class="slick-next lh1 slick-box"><span></span></button>',
                prevArrow: '<button aria-label="button" class="slick-prev lh1 slick-box"><span></span></button>'
            }
        },
        windowScreen: {
            desktop: 768,
            mobile: 767
        },
        productZoom: {
            zoomSizeMode: "image",
            autoInside: !0,
            tintOpacity: 0,
            zoomPosition: "inside"
        },
        countdown: {
            dealCountdownReg: "([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2})",
            dealCountdownTpl: $("#bt_countdown_html").html()
        },
        compare: {
            cookieName: "bt-compare",
            firstLoaded: !1
        },
        wishlist: {
            cookieName: "bt-wishlist"
        },
        productNameHolder: "product_title",
        notifyDuration: 300,
        notifyTimeout: 3e3,
        notifyClassTypes: {
            success: "success",
            danger: "danger"
        },
        rp: {
            cookieName: "rp_hide",
            duration: 700
        },
        newsPopup: {
            cookieName: "hide_news_popup"
        },
        promo: {
            cookieName: "hide_promo"
        },
        cartTerms: {
            cookieName: "cart_terms"
        },
        newsTerms: {
            cookieName: "news_terms"
        },
        recentView: {
            cookieName: "recent_view_products"
        },
        overlay: {
            openPrefixEvent: "showOverlay.",
            hidePrefixEvent: "hideOverlay."
        },
        desktopNav: {
            overlaySuffixEvent: "hoz-megamenu",
            view: "navigation"
        },
        verticalNav: {
            view: "navigation-vertical"
        }
    },
    data: {
        productGroup: {},
        outStockGroup: {},
        updatingProductOptions: !1,
        productVideo: {
            currentPlayer: null,
            currentType: null,
            loadYoutubeApi: !1,
            loadVimeoApi: !1,
            vimeoPlayers: {}
        },
        productGroupInfiniteScroll: {},
        updateCartRequests: [],
        favicon: null,
        zoom: {
            single: null,
            quickView: null
        },
        rp: {
            openTimeInterval: null
        },
        modalVideoWorking: !1,
        loadedSnippets: [],
        thresholdMenu: 0,
        stickyMenuObj: null,
        resizeEventName: "bt_resize_window",
        scrollEventName: "bt_scroll_window",
        cacheWindowWidth: $(window).width(),
        isTouchDevide: !1,
        thresholdMenuWithPromotion: 33,
        sliderIndex: 0,
        wishlist: {
            loaded: !1
        },
        cookieArray: {},
        pageLoaded: !1,
        searchSuggestionCurrentType: "product",
        searchSuggestionCurrentAjaxRequest: null,
        customColorCodes: null,
        customColorCodesLoading: !1,
        customColorCodesStack: [],
        initTopBar: !1,
        ajaxSetup: !1,
        openingDesktopNav: !1
    },
    shuffleArray: function(t) {
        for (var e = t.length - 1; 0 < e; e--) {
            var i = Math.floor(Math.random() * (e + 1)),
                o = t[e];
            t[e] = t[i], t[i] = o
        }
        return t
    },
    getRandomInt: function(t, e) {
        return Math.floor(Math.random() * (e - t + 1)) + t
    },
    getCookie: function(t) {
        try {
            return $.cookie(t)
        } catch (t) {}
    },
    setCookie: function(t, e, i) {
        try {
            var o = {
                path: "/"
            };
            o.expires = i || 7, $.cookie(t, e, o)
        } catch (t) {}
    },
    stripScripts: function(t) {
        var e = document.createElement("div");
        e.innerHTML = t;
        for (var i = e.getElementsByTagName("script"), o = i.length; o--;) i[o].parentNode.removeChild(i[o]);
        return e.innerHTML
    },
    callAjax: function(t, e, i, o, a, s) {
        var n = this;
        return $.ajax({
            type: e,
            url: t,
            data: i,
            dataType: o,
            error: function(t, e, i) {
                n.hideLoadingFull(), null != t.responseJSON && (null != t.responseJSON.description && null != t.responseJSON.description ? n.showNotify(t.responseJSON.description, n.options.notifyClassTypes.danger) : null != t.responseJSON.message && n.showNotify(t.responseJSON.message, n.options.notifyClassTypes.danger)), s && s()
            },
            success: function(t) {
                a(t)
            }
        })
    },
    renderSectionByAjaxApi: function(t, e, i) {
        var o = e;
        o.section_id = t, o.page = 2, this.callAjax(theme.currentUrl, "GET", o, null, i)
    },
    requestUpdateCart: function(t, e, i, o) {
        $(this.data.updateCartRequests).each(function(t, e) {
            e && 4 != e.readyState && e.abort()
        }), this.data.updateCartRequests = [], this.data.updateCartRequests.push(this.callAjax(theme.cartChangeUrl, "POST", {
            line: t,
            quantity: e
        }, "json", function(t) {
            i && i(t)
        }, o))
    },
    requestEmptyCart: function(e) {
        this.callAjax(theme.cartClearUrl, "POST", {}, "json", function(t) {
            e && e(t)
        })
    },
    resizeImage: function(t, e) {
        try {
            if ("original" == e) return t;
            var i = t.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
            return i[1] + "_" + e + "." + i[2]
        } catch (e) {
            return t
        }
    },
    isInViewport: function(t, e) {
        var i = t.offset().top,
            o = i + t.outerHeight(),
            a = $(e).scrollTop(),
            s = a + $(e).height();
        return a < o && i < s
    },
    rteWrapTable: function(t) {
        t.find("table").each(function() {
            $(this).removeAttr("style").removeAttr("border").addClass("table table-bordered table-striped").wrap('<div class="table-responsive"></div>')
        })
    },
    rteWrapEmbed: function(t) {
        t.find(".embed-responsive-item,iframe,embed,object,video").each(function() {
            $(this).css("max-width", "100%")
        })
    },
    rteWrap: function(t) {
        "string" == typeof t && (t = $(t)), t.hasClass("rte-wrapped") || (this.rteWrapTable(t), this.rteWrapEmbed(t), t.addClass("rte-wrapped"))
    },
    startLoadingBtn: function(t) {
        t.find("i").addClass(this.selectors.loadingAjaxClass)
    },
    endLoadingBtn: function(t) {
        t.find("i").removeClass(this.selectors.loadingAjaxClass)
    },
    showLoadingFull: function() {
        this.data.initTopBar || (topbar.config(topbarConfig), this.data.initTopBar = !0), topbar.show()
    },
    hideLoadingFull: function() {
        topbar.hide()
    },
    getPriceHtml: function(t) {
        return theme.Currency.formatMoney(t, theme.moneyFormat)
    },
    handleString: function(t) {
        return t.toLowerCase().replace(/\"/g, "").replace(/\'/g, "").replace(/[\(,\*,\)]/g, "").replace(/  /g, " ").replace(/ /g, "-")
    },
    convertCurrencySilence: function(t) {
        BtCurrency.convertSilence(shopCurrency, BtCurrency.currentCurrency, t)
    },
    callSnippetAjax: function(t, e) {
        this.callAjax(theme.rootUrl, "GET", {
            view: "snippet",
            q: t
        }, null, function(t) {
            e(t)
        })
    },
    loadSnippetAjax: function(e, i, o) {
        var a; - 1 < this.data.loadedSnippets.indexOf(e) ? i() : (a = this).callSnippetAjax(e, function(t) {
            a.data.loadedSnippets.push(e), 0 == $(".snippet-error", t).length && ($("body").append(t), setTimeout(function() {
                i()
            }, o || 300))
        })
    },
    processSameId: function(s) {
        var t = s.match(/data-clone-id=\"(.*?)\"/g);
        return null != t && $.each(t, function(t, e) {
            var i = e.replace(/data-clone-id=/g, "").replace(/"/g, ""),
                o = "clone-" + Math.floor(100 * Math.random()),
                a = new RegExp(i, "g");
            s = s.replace(a, o)
        }), s
    },
    showPopup: function(t) {
        var e = 0,
            i = this,
            o = t.replace("#", "");
        0 < $(".modal.in:not(." + o + ")").length && ($(".modal.in:not(." + o + ")").each(function() {
            i.hidePopup("#" + $(this).attr("id"))
        }), e = 500), setTimeout(function() {
            $(t).modal("show")
        }, e)
    },
    hidePopup: function(t) {
        $(t).modal("hide")
    },
    showNotify: function(t, e) {
        var i = $(this.selectors.notify),
            o = this;
        i.removeClass(this.selectors.notifyClassTypes), i.addClass("alert-" + e), i.html(t), i.hasClass("active") ? (this.data.notifyTimeout && clearTimeout(this.data.notifyTimeout), this.hideNotify()) : i.slideDown(o.options.notifyDuration, function() {
            i.addClass("active"), o.hideNotify()
        })
    },
    hideNotify: function() {
        var t = $(this.selectors.notify),
            e = this;
        this.data.notifyTimeout = setTimeout(function() {
            t.slideUp(e.options.notifyDuration, function() {
                t.removeClass("active")
            })
        }, this.options.notifyTimeout)
    },
    showOverlay: function(t) {
        $("body").addClass(this.selectors.showOverlayClass), $(this.selectors.overlay).attr("data-event", t)
    },
    hideOverlay: function() {
        $("body").removeClass(this.selectors.showOverlayClass), $(this.selectors.overlay).removeAttr("data-event")
    },
    hideOverlayWithEvent: function() {
        $(document).trigger(this.options.overlay.hidePrefixEvent + $(this.selectors.overlay).attr("data-event")), this.hideOverlay()
    },
    initOverlay: function() {
        var t = this;
        $(document).on("click", this.selectors.overlay, function() {
            t.hideOverlayWithEvent()
        })
    },
    runLoadingDropdownNavInAjax: function(t, e, i) {
        var o = this.selectors[e].parentItem,
            a = this.selectors[e].dropdown,
            s = (this.options[e].view, $(t).attr("data-section-id"));
        this.callAjax(theme.rootUrl, "GET", {
            view: "ajax",
            section_id: s
        }, null, function(e) {
            $(t).find(o).each(function() {
                var t = "#" + $(this).attr("id");
                $(this).append($(t, e).children(a))
            }), i()
        })
    },
    openMobileNav: function() {
        $(".mobile-nav").find(".link-list__item__link.active").each(function() {
            $(this).parents(".link-list__item__dropdown").each(function() {
                var t = $(this);
                t.show(), t.parent(".link-list__item").addClass("open")
            })
        })
    },
    initMobileNavigation: function() {
        var a = "open",
            s = this.selectors.workingClass;

        function n(t, e) {
            t.hasClass(s) || (t.addClass(s), t.children(".mobile-nav__children").hide(), t.removeClass(s), e && e())
        }
        $(document).on("click", ".mobile-nav__arrow", function(t) {
            t.preventDefault();
            var e, i = $(this),
                o = $(this).parents(".mobile-nav__item").first();
            o.hasClass(s) || (o.hasClass(a) ? (o.removeClass(a), n(o)) : (o.addClass(a), (e = o).hasClass(s) || (e.addClass(s), e.children(".mobile-nav__children").fadeIn(300, function() {
                e.removeClass(s)
            })), o.siblings("." + a).each(function() {
                var t = i.position().top - 60;
                $(this).removeClass(a), n($(this), function() {
                    BT.isInViewport(i, window.self) || o.parents(".bt-sidebar__inner").scrollTop(t)
                }.bind(this))
            })))
        })
    },
    showDropdown: function(t) {
        var e = this;
        t.find(".load-header-cart").each(function() {
            $(this).removeClass("load-header-cart"), $(this).html(e.processSameId($("#header-cart-canvas").html()))
        }), t.addClass("active"), t.hasClass(this.options.dropdown.noOverLayClass) || this.showOverlay(this.options.dropdown.overlaySuffixEvent)
    },
    hideDropdown: function(t) {
        t.removeClass("active"), t.hasClass(this.options.dropdown.noOverLayClass) || this.hideOverlay()
    },
    initDropdown: function() {
        var o = this.selectors.dropdown,
            a = this,
            t = (this.selectors.overlay, this.options.overlay.hidePrefixEvent + this.options.dropdown.overlaySuffixEvent);
        $(document).on("mouseenter", o.wrap, function() {
            a.data.isTouchDevide || a.showDropdown($(this))
        }).on("mouseleave", o.wrap, function(t) {
            a.data.isTouchDevide || $(t.target).is(":focus") || a.hideDropdown($(this))
        }), $(document).on("click", o.trigger, function(t) {
            var e, i;
            a.data.isTouchDevide && (t.preventDefault(), (e = $(this).parents(o.wrap).first()).hasClass("active") ? a.hideDropdown(e) : (null != (i = e.attr("data-group")) && $(o.wrap + '[data-group="' + i + '"].active').removeClass("active"), a.showDropdown(e)))
        }), $(document).on(t, function(t) {
            0 < $(o.wrap + ".active").length && $(o.wrap + ".active").removeClass("active")
        })
    },
    getInputFloatSelector: function() {
        var t = this.selectors.floatField;
        return t + ' input[type="text"],' + t + ' input[type="password"],' + t + ' input[type="number"],' + t + ' input[type="email"],' + t + ' input[type="tel"]'
    },
    initFloatField: function() {
        var t = this.selectors.floatField,
            e = this.getInputFloatSelector();
        $(document).on("focus", e, function() {
            $(this).parents(t).addClass("active focus")
        }), $(document).on("blur", e, function() {
            "" == $(this).val() && $(this).parents(t).removeClass("active"), $(this).parents(t).removeClass("focus")
        }), 0 < $(this.selectors.floatFieldFirstFocus).length && $(this.selectors.floatFieldFirstFocus).parents(t).addClass("active focus")
    },
    detectAutoFields: function() {
        var e = this.selectors.floatField,
            t = this.getInputFloatSelector();
        $(t).each(function() {
            try {
                "" == $(this).val() && !$(this).is(":-webkit-autofill") || $(this).parents(e).addClass("active")
            } catch (t) {
                "" != $(this).val() && $(this).parents(e).addClass("active")
            }
        })
    },
    loadCssJsLib: function(i, t) {
        var e, o; - 1 < theme.loadedLibs.indexOf(i) ? t && t() : null != theme.libs[i] && (e = theme.libs[i].css, o = theme.libs[i].js, null != e && -1 == theme.loadedCssLibs.indexOf(i) && (theme.loadedCssLibs.push(i), $.each(e, function(t, e) {
            $("<link/>", {
                rel: "stylesheet",
                type: "text/css",
                href: "https:" + e
            }).appendTo("head")
        })), null != o ? null == theme.pendingJsLibs[i] ? (theme.pendingJsLibs[i] = [], 0 == this.data.ajaxSetup && ($.ajaxSetup({
            cache: !0
        }), this.data.ajaxSetup = !0), $.getScript("https:" + o).then(function() {
            theme.loadedLibs.push(i), t && t(), $.each(theme.pendingJsLibs[i], function(t, e) {
                e(), delete theme.pendingJsLibs[i][t]
            })
        })) : t && theme.pendingJsLibs[i].push(t) : (theme.loadedLibs.push(i), t && t()))
    },
    initSidebar: function() {
        var s = this;
        $(document).on(this.options.sidebar.openEvent, this.selectors.sidebar.btn, function(t) {
            t.preventDefault(), t.stopPropagation();
            var e = $(this).attr("data-placement"),
                i = $(this).attr("data-placement-mobile"),
                o = 768 <= s.data.cacheWindowWidth || null == i ? e : i,
                a = $(this).attr("data-target");
            $("body").hasClass(s.selectors.sidebar.openClass) || s.showSidebar(a, o, s.options.sidebar.duration)
        }), this.initHideNavMobile(300)
    },
    initHideNavMobile: function(e) {
        var i = this,
            t = this.selectors.sidebar.closeBtnCanvas + "," + this.selectors.sidebar.closeSidebarBtn,
            o = this.options.overlay.hidePrefixEvent + this.options.sidebar.overlaySuffixEvent;
        $(document).on(i.options.sidebar.closeEvent, t, function(t) {
            t.preventDefault(), t.stopPropagation(), $("body").hasClass(i.selectors.sidebar.openClass) && i.hideSidebar(e, $(i.selectors.overlay).attr("data-block"))
        }), $(document).on(o, function() {
            i.hideSidebar(e, $(i.selectors.overlay).attr("data-block"))
        })
    },
    showSidebar: function(t, e, i) {
        $(t).outerWidth();
        var o = {};
        $(t).removeAttr("style"), "left" == e ? (o.left = 0, $(t).css({
            left: "-100%"
        }), $(t).css({
            right: "auto"
        })) : "right" == e ? (o.right = 0, $(t).css({
            right: "-100%"
        }), $(t).css({
            left: "auto"
        })) : o = "slideDown", $("body").trigger("beforeShowSidebar-" + t.replace("#", ""));
        var a = this.selectors.overlay;
        $(a).attr("data-block", t), this.showOverlay(this.options.sidebar.overlaySuffixEvent);
        var s;
        "slideDown" == o ? (s = this.selectors.sidebar.openClass + "--" + $(t).attr("id"), $("body").addClass(this.selectors.sidebar.openClass + " " + s), $(t).slideDown(i, function() {
            $(a).addClass(e)
        })) : (s = this.selectors.sidebar.openClass + "--" + $(t).attr("id"), $("body").addClass(this.selectors.sidebar.openClass + " " + s), $(t).animate(o, {
            duration: i,
            complete: function() {
                $(a).addClass(e)
            }
        }))
    },
    hideSidebar: function(t, e) {
        var i = this.selectors.overlay,
            o = $(i).hasClass("left") ? "left" : $(i).hasClass("up") ? "up" : "right",
            a = ($(e).outerWidth(), {});
        "left" == o ? a.left = "-100%" : "right" == o ? a.right = "-100%" : a = "slideUp";
        var s = this.selectors.sidebar.openClass + "--" + $(e).attr("id");
        $("body").removeClass(this.selectors.sidebar.openClass + " " + s), "slideUp" == a ? $(e).slideUp(t, function() {
            $(i).removeClass(o), $(e).removeAttr("style")
        }) : $(e).animate(a, {
            duration: t,
            complete: function() {
                $(i).removeClass(o), $(e).removeAttr("style")
            }
        }), this.hideOverlay()
    },
    initSlickSlider: function(e, t) {
        var i = {};
        if ($.extend(!0, i, this.options.slider), e.attr("data-slider")) try {
            i = $.extend(!0, i, JSON.parse(e.attr("data-slider")))
        } catch (t) {
            e.addClass("failed"), i = this.options.slider
        }
        t && (e.off("beforeChange"), e.off("afterSlideChange"), e.on("beforeChange", function(t, e, i, o) {
            e.$slider.find(".slick-current").addClass("animate-out")
        }), e.on("afterChange", function(t, e, i) {
            e.$slider.find(".slick-slide").removeClass("animate-out")
        })), e.slick(i), /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && e.hasClass("need-refresh") && e.slick("refresh")
    },
    initSliderEle: function(t, e) {
        if (this.data.cacheWindowWidth >= this.options.windowScreen.desktop || !t.hasClass(this.selectors.slider.useTouchMobile)) {
            var i = t.parent();
            i.height(i.height()), i.css({
                overflow: "hidden"
            });
            try {
                this.preInitSlider(t), this.initSlickSlider(t, e), setTimeout(function() {
                    i.removeAttr("style")
                }, 500)
            } catch (t) {
                i.removeAttr("style")
            }
        } else this.preInitSlider(t)
    },
    preInitSlider: function(t, e) {
        "string" == typeof t && (t = $(t));
        var i = this.selectors.slider.overFloatClasses;
        e && (i += " hide"), t.find("." + i.replace(/ /g, ",.")).removeClass(i)
    },
    triggerResizeSlider: function(t) {
        var e = this;
        t.hasClass(e.selectors.slider.useTouchMobile) && $(window).on(e.data.resizeEventName, function() {
            e.data.cacheWindowWidth >= e.options.windowScreen.desktop ? t.hasClass("slick-initialized") || e.initSlickSlider(t) : t.hasClass("slick-initialized") && t.hasClass(e.selectors.slider.useTouchMobile) && setTimeout(function() {
                t.slick("unslick")
            }, 300)
        })
    },
    getSliderSelector: function() {
        return this.selectors.slider.default+":not(" + this.selectors.waitingData + ")"
    },
    initSlider: function(t, e, i) {
        var o = this,
            a = this.getSliderSelector();
        "string" == typeof t && (t = $(t));
        var s, n = t.find(a);
        n.length && (this.data.cacheWindowWidth >= this.options.windowScreen.desktop || !t.hasClass("touch-mobile") ? e ? (s = "init_slider_" + this.data.sliderIndex, this.data.sliderIndex++, this.initScrollingWindowTriggerOnce(t, s, -170, function() {
            n.each(function() {
                var t = $(this);
                o.initSliderEle(t, i), o.triggerResizeSlider(t)
            })
        })) : n.each(function() {
            var t = $(this);
            o.initSliderEle(t, i), o.triggerResizeSlider(t)
        }) : (o.preInitSlider(t), n.each(function() {
            var t = $(this);
            o.triggerResizeSlider(t)
        })))
    },
    destroySlider: function(t) {
        "string" == typeof t && (t = $(t));
        var e = t.find(this.getSliderSelector());
        e.length && e.each(function() {
            var t = $(this);
            t.hasClass("slick-initialized") && t.slick("unslick")
        })
    },
    refreshSliderInTabs: function() {
        var a = this;
        $('a[data-toggle="tab"]').on("shown.bs.tab", function(t) {
            var e = a.data.cacheWindowWidth,
                i = $(t.target).attr("href"),
                o = a.selectors.slider.default+":not(" + a.selectors.waitingData + ")";
            0 < $(i).find(o).length && $(i).find(o).each(function() {
                var t = $(this);
                e >= a.options.windowScreen.desktop ? t.hasClass("slick-initialized") && t.slick("setPosition") : !t.hasClass(a.selectors.slider.useTouchMobile) && t.hasClass("slick-initialized") && t.slick("setPosition")
            })
        })
    },
    submitCartForm: function(t, o, a, e) {
        var s = this;
      //alert(theme.cartAddUrl);
        t.valid() ? t.ajaxSubmit({
            url: theme.cartAddUrl,
            type: "post",
            dataType: "json",
            error: function(t, e, i) {
                null != t.responseJSON.description && null != t.responseJSON.description ? s.showNotify(t.responseJSON.description, s.options.notifyClassTypes.danger) : null != t.responseJSON.message && s.showNotify(t.responseJSON.message, s.options.notifyClassTypes.danger), s.endLoadingBtn(o), o.removeClass(s.selectors.workingClass)
            },
            uploadProgress: function(t, e, i, o) {},
            success: function(t, e, i, o) {
                a(t)
            }
        }) : e()
    },
    updateFaviconBadge: function(t) {
        if (!theme.favicon.enable || this.data.cacheWindowWidth < 768 || !t) return !1;
        null == this.data.favicon && (this.data.favicon = new Favico({
            animation: "slide",
            position: theme.favicon.pos,
            bgColor: theme.favicon.bkgColor,
            textColor: theme.favicon.textColor
        })), 0 < (t = parseInt(t)) ? this.data.favicon.badge(t) : this.data.favicon.reset()
    },
    updateHeaderCartHtml: function(t) {
        var n, r;
        ("redirect" != theme.cartAction && "redirect_checkout" != theme.cartAction || 0 != t) && (n = this.selectors.cart, r = this, new Promise(function(s, t) {
            r.callAjax(theme.rootUrl, "GET", {
                view: "header_cart"
            }, null, function(t) {
                var e = $(n.header, t).html(),
                    i = n.header;
                $(i).each(function() {
                    $(this).html(r.processSameId(e))
                });
                var o = $(n.number, t).html(),
                    a = $(n.total, t).html();
                $(n.number).html(o), $(n.total).html(a), r.updateFaviconBadge(o), s(n.header)
            })
        }).then(function(t) {
            null != t && (r.convertCurrencySilence(t + " span.money"), $(document).trigger("ajaxCart.afterUpdateHeaderCartHtml")), r.convertCurrencySilence(n.total + " span.money"), r.resetCartTerms(), $(document).trigger("ajaxCart.afterCartLoad"), window.Shopify && null != Shopify.StorefrontExpressButtons && !$("body").hasClass("template-cart") && Shopify.StorefrontExpressButtons.initialize()
        }, function(t) {}))
    },
    generateCartMessage: function(t) {
        return theme.strings.addCartMsg.replace(this.options.productNameHolder, "<strong>" + t + "</strong>")
    },
    updateCartMessage: function(t) {
        $(this.selectors.cartMessage).removeClass("hide").html(this.generateCartMessage(t))
    },
    showPopupCart: function(t, a) {
        var s = this;
        this.loadSnippetAjax("popup-cart", function() {
            s.loadUpsellInPopup(t.handle, t.title), s.updateCartMessage(t.title);
            var e = s.selectors.cartModal;
            $(e.productImage).attr("href", t.url).attr("title", t.title).find("img").attr("src", s.resizeImage(t.image, "360x")).attr("alt", t.title), $(e.productName + " > a").attr("title", t.title).attr("href", t.url).html(t.product_title);
            var o, i = $(e.variantTitle);
            i.html(""), null != t.variant_title && $(t.options_with_values).each(function(t, e) {
                i.append('<span class="cart-response__meta-variant-title w100 db">' + e.name + ": " + e.value + "</span>")
            }), t.properties ? ((o = $(e.variantProp)).removeClass("hide"), o.html(""), $.each(t.properties, function(t, e) {
                var i = $('<span class="gutter-ele-small-top w100 db cart__meta-text"></span>');
                i.append(t + ": "), 0 < e.indexOf("/uploads/") ? i.append(e.split("/").pop()) : i.append(e), o.append(i)
            })) : $(e.variantProp).addClass("hide"), $(e.qty).html(t.quantity), $(e.price).html(s.getPriceHtml(t.price)), $(e.linePrice).html(s.getPriceHtml(t.line_price)), s.resetCartTerms(), theme.enableFreeShipping ? s.callAjax(theme.cartJsonUrl, "GET", null, "json", function(t) {
                s.convertProgressBar(t.total_price, !0), BtCurrency.convertSilence(shopCurrency, BtCurrency.currentCurrency, e.wrap + " span.money"), s.showPopup(e.wrap), a()
            }) : (BtCurrency.convertSilence(shopCurrency, BtCurrency.currentCurrency, e.wrap + " span.money"), s.showPopup(e.wrap), a())
        })
    },
    convertProgressBar: function(t, e) {
        var i, o, a, s;
        (theme.enableFreeShipping && null != BtCurrency.rates && useCurrencyConverterPlusEngine && defaultCurrency != shopCurrency && 0 != $(".free-shipping-text").length || null != e) && (s = (i = useCurrencyConverterPlusEngine && defaultCurrency != shopCurrency && null != BtCurrency.rates ? theme.freeShippingGoal / BtCurrency.rates[shopCurrency] : theme.freeShippingGoal) <= (t = null != t ? t : parseFloat($(".free-shipping-text--data").attr("data-current"))) ? ($(".free-shipping-text").text(theme.freeShippingGoalText), 100) : (o = i - t, a = "<strong>" + BT.getPriceHtml(o) + "</strong>", $(".free-shipping-text").html(theme.freeShippingProgressText.replace("[remain_amount]", a)), Math.floor(100 * t / i)), $(".cart__free-progress-bar").attr("aria-valuenow", s).css("width", s + "%"), $(".cart__free-progress-bar span").text(s + "%"))
    },
    enableCartTerms: function() {
        $(this.selectors.cartTerms.checkbox).prop("checked", !1), $(this.selectors.cartTerms.checkoutBtn).addClass("disabled"), $(this.selectors.cartTerms.paymentBtn).addClass("disabled")
    },
    disableCartTerms: function() {
        $(this.selectors.cartTerms.checkbox).prop("checked", !0), $(this.selectors.cartTerms.checkoutBtn).removeClass("disabled"), $(this.selectors.cartTerms.paymentBtn).removeClass("disabled")
    },
    resetCartTerms: function() {
        this.agreeCartTerms() ? this.disableCartTerms() : this.enableCartTerms()
    },
    showCartTermsErrorMsg: function(t) {
        t.addClass("notify-terms"), 0 == t.siblings(".alert").length && t.parent().append('<div class="alert alert-danger w100 distance-top-ele" style="margin-bottom:0;display:none;">' + theme.strings.cartTermsErrorMsg + "</div>"), t.siblings(".alert").show(300)
    },
    hideCartTermsErrorMsg: function() {
        var t = $(this.selectors.cartTerms.label);
        t.removeClass("notify-terms"), t.siblings(".alert").hide(300)
    },
    initAgreeCartTems: function() {
        if (!theme.cartTerms) return !0;
        var e = this,
            i = this.options.cartTerms.cookieName,
            o = this.selectors.cartTerms;
        this.resetCartTerms(), $(document).on("change", o.checkbox, function(t) {
            t.preventDefault(), $(this).is(":checked") ? (e.setCookie(i, 1), $(this).hasClass("redirect") ? window.location.href = "/checkout" : ($(o.checkbox).not(this).prop("checked", !0), $(o.checkoutBtn).removeClass("disabled"), $(o.paymentBtn).removeClass("disabled"), e.hideCartTermsErrorMsg())) : (e.setCookie(i, null), $(o.checkbox).not(this).prop("checked", !1), $(o.checkoutBtn).addClass("disabled"), $(o.paymentBtn).addClass("disabled"))
        }), $(document).on("click", ".shopify-payment-button," + o.checkoutBtn, function(t) {
            $(this).hasClass("disabled") ? (t.preventDefault(), e.showCartTermsErrorMsg($(this).parent().siblings(o.wrap).find(o.label).first())) : $(this).hasClass("checkout-btn--redirect") && (window.location.href = theme.rootUrl + "checkout")
        })
    },
    agreeCartTerms: function() {
        if (!theme.cartTerms) return !0;
        var t = this.options.cartTerms.cookieName,
            e = this.getCookie(t);
        return null != e && null != e && "null" != e
    },
    runCartAction: function(t, e) {
        var i;
        "redirect" == theme.cartAction ? window.location.href = theme.cartUrl : "redirect_checkout" == theme.cartAction ? this.agreeCartTerms() ? window.location.href = "/checkout" : (this.updateHeaderCartHtml(!0), (i = this).loadSnippetAjax("popup-terms", function() {
            0 < $(i.selectors.cartTerms.popup).length && (i.showPopup(i.selectors.cartTerms.popup), e())
        })) : "popup" == theme.cartAction ? (this.updateHeaderCartHtml(!1), this.showPopupCart(t, e)) : "open_cart" == theme.cartAction ? (this.updateHeaderCartHtml(!1), setTimeout(function() {
            $(".cart-sidebar-trigger").trigger("click"), e()
        }, 300)) : ("notify_msg" == theme.cartAction ? (this.updateHeaderCartHtml(!1), this.showNotify(this.generateCartMessage(t.title), this.options.notifyClassTypes.success)) : this.updateHeaderCartHtml(!1), e())
    },
    initCartEvent: function() {
        var a = this,
            t = this.selectors.cart;
        $(document).on("click", t.addBtn, function(t) {
            t.preventDefault();
          
            var e, i = $(this);
            i.hasClass(a.selectors.workingClass) || (e = $(this).parents("form"), i.addClass(a.selectors.workingClass), a.startLoadingBtn(i), a.submitCartForm(e, i, function(t) {
                a.runCartAction(t, function() {
                    a.endLoadingBtn(i), ("open_cart" == theme.cartAction || "notify_msg" == theme.cartAction) && 0 < i.parents(".modal").length && a.hidePopup("#" + i.parents(".modal").first().attr("id"))
                }), i.removeClass(a.selectors.workingClass)
            }, function() {
                a.endLoadingBtn(i), i.removeClass(a.selectors.workingClass)
            }))
        }), $(document).on("click", t.updateBtn, function(t) {
            if (t.preventDefault(), !$(this).hasClass(a.selectors.workingClass)) {
                $(this).addClass(a.selectors.workingClass), "tooltip" == $(this).attr("data-toggle") && ($(this).tooltip("hide"), $(this).hasClass("cart__remove") && $(this).removeAttr("data-toggle"));
                var e = $(this).attr("data-index"),
                    i = $(this).attr("data-value"),
                    o = $(this).find("i");
                if (o.addClass(a.selectors.loadingAjaxClass), isNaN(i)) {
                    if (0 == $(i).length) return $(this).find("i").removeClass(a.selectors.loadingAjaxClass), void $(this).removeClass(a.selectors.workingClass);
                    i = $(i).val()
                }
                a.requestUpdateCart(e, i, function() {
                    a.updateHeaderCartHtml(!0)
                }, function() {
                    o.removeClass(a.selectors.loadingAjaxClass)
                })
            }
        }), $(document).on("change", t.qtyInput, function() {
            var t = $(this).attr("data-line");
            a.showLoadingFull(), a.requestUpdateCart(t, $(this).val(), function() {
                a.updateHeaderCartHtml(!0), a.hideLoadingFull()
            }, function() {
                a.hideLoadingFull()
            })
        })
    },
    hideSearchFull: function() {
        $(this.selectors.searchFull.wrap).fadeOut(), $("body").removeClass("open-search-suggest")
    },
    renderSearchFullContent: function(t) {
        var e = this.selectors.searchFull;
        this.data.searchSuggestionCurrentAjaxRequest = null, $(e.loading).removeClass(this.selectors.loadingAjaxClass), $(e.content + "__" + this.data.searchSuggestionCurrentType).addClass(e.loadedClass);
        var i = $(e.content + "__" + this.data.searchSuggestionCurrentType + " " + e.result);
        i.html(t), $(e.suggestProducts).hide(), "product" == this.data.searchSuggestionCurrentType && (this.convertCurrencySilence(i.find("span.money")), this.initDealCountdown(i), this.applyCustomColorSwatches(i), this.reLoadReview(i), this.popularAddedWishlistItems(i))
    },
    initSearchSuggestion: function() {
        var s, n, r = this.selectors.searchFull,
            a = "working",
            l = (this.selectors.promo.wrap, this),
            d = void 0,
            t = !1;

        function c() {
            t || (t = !0, l.callSnippetAjax("search-full-suggest", function(t) {
                $(r.suggestProducts).html(t)
            })), $(r.wrap).fadeIn(), $("body").addClass("open-search-suggest")
        }
        $(document).on("click", r.trigger, function(t, e, i) {
            var o;
            t.preventDefault(), null != e && (d = e), $(this).hasClass(a) || ((o = $(this)).addClass(a), c(), o.removeClass(a), null != d && ($(r.input).val(d), $(r.input).trigger("change"), d = void 0), $(r.input).focus())
        }), $(document).on("click", r.close, function(t) {
            t.preventDefault(), l.hideSearchFull()
        }), theme.searchSuggest.enable && (s = !"loaded", n = {
            options: {
                prefix: "last"
            }
        }, $(document).on("keyup change", r.input, $.throttle(500, function(t) {
            var e, i = $(this),
                o = i.val();
            3 <= o.length && o != i.attr("data-term") && (null != l.data.searchSuggestionCurrentAjaxRequest && l.data.searchSuggestionCurrentAjaxRequest.abort(), e = theme.searchUrl + "?view=suggest&q=" + o + "&type=" + l.data.searchSuggestionCurrentType, $(r.loading).addClass(l.selectors.loadingAjaxClass), i.attr("data-term", o), s = !0, l.data.searchSuggestionCurrentAjaxRequest = l.callAjax(e, "GET", n, null, function(t) {
                $(r.tabList).removeClass("hide"), $(r.content).removeClass("hide"), $(r.tabContent + ":not(.active)").removeClass("loaded"), s = !1, l.renderSearchFullContent(t), $(window).trigger("renderedSearchFullContent", [o])
            }))
        })), $(document).on("keyup change", r.inputSync, $.throttle(500, function(t) {
            var e = $(this).val();
            3 <= e.length && e != $(this).attr("term") && ($(r.inputSync).siblings("button").find("i").addClass(l.selectors.loadingAjaxClass), $(r.trigger).trigger("click", [e, !0]))
        })), $(window).on("renderedSearchFullContent", function(t, e) {
            $(r.inputSync).attr("term", e), $(r.inputSync).siblings("button").find("i").removeClass(l.selectors.loadingAjaxClass)
        }), $(document).on("shown.bs.tab", r.tabTitle, function(t) {
            var e, i, o = $(t.target),
                a = $(o.attr("href"));
            s && ($(r.tabContent + ":not(.active)").removeClass("loaded"), s = !1), l.data.searchSuggestionCurrentType = o.attr("data-type"), a.hasClass(r.loadedClass) || (null != l.data.searchSuggestionCurrentAjaxRequest && l.data.searchSuggestionCurrentAjaxRequest.abort(), e = $(r.input).val(), i = theme.searchUrl + "?view=suggest&q=" + e + "&type=" + l.data.searchSuggestionCurrentType, l.data.searchSuggestionCurrentAjaxRequest = l.callAjax(i, "GET", n, null, function(t) {
                l.renderSearchFullContent(t), $(window).trigger("renderedSearchFullContent", [e])
            }))
        }))
    },
    loadUpsell: function(d) {
        var c, t, u, o, p;
        void 0 !== d && 0 != d.length && (t = (c = this).selectors.upsell, u = d.attr("data-handle"), (o = d.find(t.list)).hasClass("slick-initialized") && o.slick("unslick"), o.html(""), o.siblings(this.selectors.loadingNotFull).show(), d.show(), p = upsellRandom ? 100 : parseInt(d.attr("data-limit")), this.callAjax(theme.rootUrl + "products/" + u, "GET", {
            view: "upsell_tags"
        }, null, function(l) {
            new Promise(function(i, t) {
                var e = $.parseJSON(l.replace("\x3c!-- BEGIN template --\x3e", "").replace("\x3c!-- product.upsell_tags --\x3e", "").replace("\x3c!-- END template --\x3e", "")),
                    o = [],
                    a = [],
                    s = 0,
                    n = e.length;
                0 == n && i([]);
                var r = d.attr("data-slider") ? "upsell_slider" : "upsell";
                $(e).each(function(e, t) {
                    c.callAjax(theme.collectionAllUrl + "/" + t, "GET", {
                        view: r
                    }, null, function(t) {
                        $(".product-item", t).each(function() {
                            a.indexOf($(this).attr("data-id")) < 0 && $(this).attr("data-handle") != u && s < p && (o.push($(this).html()), a.push($(this).attr("data-id")), s++)
                        }), e == n - 1 && (upsellRandom && (o = c.shuffleArray(o)), i(o))
                    })
                })
            }).then(function(t) {
                var i;
                o.siblings(c.selectors.loadingNotFull).hide(), 0 < t.length ? (i = 0, $(t).each(function(t, e) {
                    i < p && o.append(e), i++
                }), c.convertCurrencySilence(o.find("span.money")), c.applyCustomColorSwatches(o), c.initSlider(d, !1, !1), c.popularAddedWishlistItems(d)) : d.hide()
            }, function(t) {})
        }))
    },
    loadUpsellInPopup: function(t, e) {
        var i = $(this.selectors.cartModal.wrap + " " + this.selectors.upsell.wrap);
        void 0 !== i && 0 != i.length && (i.attr("data-handle", t), i.find(".upsell-title").html(theme.strings.upsellTitle.replace(this.options.productNameHolder, "<strong>" + e + "</strong>")), this.loadUpsell(i))
    },
    gotoSliderIndex: function(t, e) {
        t.slick("slickGoTo", e, !0)
    },
    getUnitPriceHtml: function(t, e) {
        if (null == e.unit_price_measurement) return "";
        var i = '<span class="w100 gutter-ele' + (t.hasClass("product-single") ? "" : "-small") + '-top product-price__unit db">';
        return i += this.getPriceHtml(e.unit_price) + '<span class="product-price__unit__separator">/</span><span class="product-price__unit__base">' + (1 != e.unit_price_measurement.reference_value ? e.unit_price_measurement.reference_value : "") + e.unit_price_measurement.reference_unit + "</span>", i += "</span>"
    },
    getVariantPriceHtml: function(t, e) {
        var i = "";
        return e.compare_at_price > e.price ? (i += '<span class="product-price__price">' + this.getPriceHtml(e.price) + "</span>", i += '<s class="product-price__price product-price__sale">' + this.getPriceHtml(e.compare_at_price) + "</s>", t.hasClass("product-price") || (i += '<span class="product-price__percent dib" style="display:none;">' + Math.floor((e.compare_at_price - e.price) / e.compare_at_price * 100) + "% OFF</span>")) : i += '<span class="product-price__price">' + this.getPriceHtml(e.price) + "</span>", 0 == e.available && null == t.attr("data-ignore-sold-out-text") && (i += '<span class="product-price__sold-out w100 db">' + theme.strings.soldOut + "</span>"), i += this.getUnitPriceHtml(t, e)
    },
    initProductGroup: function() {
        var f = this.selectors.productGroup,
            g = (this.options.productGroup, this);
        $(document).on("click change", f.optionValue, function(t) {
            t.preventDefault();
          console.log("clickes",window.ReCharge);
          // setTimeout(function () {
          //       if (window.ReCharge) {
          //           window.ReCharge.Widget.init();
          //       }
          //   }, 500);
            var p = $(this),
                h = p.parents(f.wrap).first(),
                m = h.attr("data-product-handle");
            $(this).hasClass("disabled") || $(this).hasClass("selected") && null != g.data.productGroup[m] || "click" == t.type && "SELECT" == t.target.nodeName || new Promise(function(e, t) {
                g.data.updatingProductOptions = !0, null == g.data.productGroup[m] ? (h.addClass(f.loadingClass), g.callAjax(theme.rootUrl + "products/" + m, "GET", {
                    view: "tjson"
                }, null, function(t) {
                    g.data.productGroup[m] = $.parseJSON(t.replace("\x3c!-- BEGIN template --\x3e", "").replace("\x3c!-- product.tjson --\x3e", "").replace("\x3c!-- END template --\x3e", "")), h.removeClass(f.loadingClass), e()
                })) : e()
            }).then(function() {
                var t = p.parents(f.option),
                    e = t.attr("data-index"),
                    i = [],
                    o = p.prop("tagName").toLowerCase();
                h.find(f.option).each(function() {
                    
                    var t = $(this).attr("data-index") != e ? $(this).hasClass("swatch") ? $(this).find(".selected").attr("data-value") : $(this).find(f.optionValue).val() : "a" == o ? p.attr("data-value") : p.val();
                    
                    $("#pg__option__values_"+m+" a").each(function(){ 
                       
                       if($(this).attr('data-value')==t){
                         //alert($(this).attr('data-variant-metafield'));
                         //alert($(this).attr('data-variant-metafield'));
                         if($(this).attr('data-variant-metafield')!=''){
                          $('#card_metafield_label_'+m).html("<span>"+$(this).attr('data-variant-metafield')+"</span>");
                         }else{
                          $('#card_metafield_label_'+m).html("");
                         }
                         //$(".product_variant_id").val($(this).val());
                       }
                     });
                    
                     $(".product-form__variants option").each(function(){ 
                       
                       if($(this).attr('data-value')==t){
                         //alert($(this).val());
                         //alert($(this).attr('data-variant-metafield'));
                         if($(this).attr('data-variant-metafield')!=''){
                           $('.custom_labelWrap').html("<span>"+$(this).attr('data-variant-metafield')+"</span>");
                         }else{
                           $('.custom_labelWrap').html("");
                         }
                         $(".product_variant_id").val($(this).val());
                       }
                     });
                    i.push(t)
                });
                var a, s, n, r, l = i.length,
                    d = [],
                    c = [],
                    u = [];
                variantsMatchOption2 = [], resetOutStockGroup = null == g.data.outStockGroup[m] && !t.hasClass("last"), isLastOption = t.hasClass("last"), resetOutStockGroup && (g.data.outStockGroup[m] = []), $.each(g.data.productGroup[m], function(t, e) {
                    e.options[0] == i[0] && (null == a && (a = e), null != s && s.available && !isLastOption || (s = e), 1 < l && (-1 == d.indexOf(e.options[1]) && d.push(e.options[1]), u.push(e), e.options[1] == i[1] && (null != n && n.available && !isLastOption || (n = e), variantsMatchOption2.push(e), 2 < l && (e.options[2] != i[2] || null != r && r.available && !isLastOption || (r = e), c.push(e.options[2]))))), resetOutStockGroup && !e.available && g.data.outStockGroup[m].push(e.title)
                }), isLastOption || (1 < l && -1 == d.indexOf(i[1]) && (variantsMatchOption2 = [], c = [], 0 < h.find(f.option + '[data-index="1"] .pg__option__values a').length ? h.find(f.option + '[data-index="1"] .pg__option__values a').each(function() {
                    -1 < d.indexOf($(this).attr("data-value")) && (i[1] = d[0])
                }) : 0 < h.find(f.option + '[data-index="1"] .pg__option__value option').length && h.find(f.option + '[data-index="1"] .pg__option__value option').each(function() {
                    -1 < d.indexOf($(this).attr("value")) && (i[1] = d[0])
                }), $.each(u, function(t, e) {
                    e.options[0] == i[0] && e.options[1] == i[1] && (null == n && e.available && (n = e), variantsMatchOption2.push(e), 2 < l && c.push(e.options[2]))
                })), 2 < l && (-1 == c.indexOf(i[2]) && (0 < h.find(f.option + '[data-index="2"] .pg__option__values a').length ? h.find(f.option + '[data-index="2"] .pg__option__values a').each(function() {
                    -1 < d.indexOf($(this).attr("data-value")) && (i[2] = c[0])
                }) : 0 < h.find(f.option + '[data-index="2"] .pg__option__value option').length && h.find(f.option + '[data-index="2"] .pg__option__value option').each(function() {
                    -1 < d.indexOf($(this).attr("value")) && (i[2] = c[0])
                })), $.each(variantsMatchOption2, function(t, e) {
                    null == r && e.options[0] == i[0] && e.options[1] == i[1] && e.options[2] == i[2] && e.available && (r = e)
                }))), null != r ? a = r : null != n ? a = n : null != s && (a = s), g.loadCssJsLib("product-global", function() {
                    g.updateNewVariant(h, a, d, c, !0, !0, t.hasClass("last")), setTimeout(function() {
                        g.data.updatingProductOptions = !1
                    }, 300)
                })
            }, function(t) {
                setTimeout(function() {
                    g.data.updatingProductOptions = !1
                }, 300)
            })
        }), $(document).on("click", f.storePickupBtn, function(t) {
            t.preventDefault(), BT.showPopup(f.storePickupModel)
        })
    },
    initQtyBox: function() {
        var o = this.selectors.qtyBox;
        $(document).on("click", o.ctrlBtn, function(t) {
            t.preventDefault();
            var e = $(this).siblings("input").first(),
                i = parseInt(e.val());
            $(this).hasClass(o.decreaseBtnClass) ? 1 < i && (e.val(i - 1), e.hasClass(o.inputSyncClass) && e.trigger("change")) : (e.val(i + 1), e.hasClass(o.inputSyncClass) && e.trigger("change"))
        })
    },
    runCountDown: function(s, n, r) {
        var i = null != s.attr("data-tpl-hour") ? $(s.attr("data-tpl-hour")).html() : theme.strings.countdownTplHour,
            o = null != s.attr("data-tpl-day") ? $(s.attr("data-tpl-day")).html() : theme.strings.countdownTplDay,
            a = null != s.attr("data-tpl-week") ? $(s.attr("data-tpl-week")).html() : theme.strings.countdownTplWeek,
            l = this;
        s.countdown(n).on("update.countdown", function(t) {
            var e = i;
            0 < t.offset.totalDays && (e = o), 0 < t.offset.weeks && (e = a), $(this).html(t.strftime(e))
        }).on("finish.countdown", function(t) {
            var e, i, o, a = parseInt(s.attr("data-extend"));
            1 == r && null != a && Number.isInteger(a) && 0 < a ? (e = "countdown_extend_" + s.data("product-id"), o = (i = new Date).getTime() + 86400 * a * 1e3, l.setCookie(e, o, null), i.setTime(o), n = i.getFullYear() + "/" + (i.getMonth() + 1) + "/" + i.getDate() + " " + i.getHours() + ":" + i.getMinutes() + ":" + i.getSeconds(), l.runCountDown(s, n, 1)) : $(this).html(theme.strings.countdownExpiredMsg)
        })
    },
    initReverseCountdown: function(t, e, i) {
        var o, a, s, n, r, l, d, c, u, p = "countdown_reverse_" + i,
            h = this.getCookie(p);
        null == h || NaN == h || "NaN" == h || "null" == h || null == h ? (4 == (n = e.split(":")).length && (r = parseInt(n[0]), l = parseInt(n[1]), d = parseInt(n[2]), c = parseInt(n[3]), 0 <= l && l <= 23 && 0 <= d && d <= 59 && 0 <= c && c <= 59 && (o = (new Date).getTime() + 1e3 * (86400 * r + 3600 * l + 60 * d + c))), this.setCookie(p, o, null)) : o = parseInt(h), null != o && (o <= (s = (a = new Date).getTime()) - 1800 && (o = null, 4 == (n = e.split(":")).length && (r = parseInt(n[0]), l = parseInt(n[1]), d = parseInt(n[2]), c = parseInt(n[3]), 0 <= l && l <= 23 && 0 <= d && d <= 59 && 0 <= c && c <= 59 && (o = s + 1e3 * (86400 * r + 3600 * l + 60 * d + c))), this.setCookie(p, o, null)), o && (a.setTime(o), u = a.getFullYear() + "/" + (a.getMonth() + 1) + "/" + a.getDate() + " " + a.getHours() + ":" + a.getMinutes() + ":" + a.getSeconds(), this.runCountDown(t, u, 2)))
    },
    initDealCountdown: function(t) {
        "string" == typeof t && (t = $(t));
        var i = this;
        0 < t.find(this.selectors.productGroup.countdown).length && t.find(this.selectors.productGroup.countdown).each(function() {
            var t, e = $(this).attr("data-timer");
            null != e && "" != e && (1 == /^\d{4}\/\d{2}\/\d{2} \d{2}:\d{2}:\d{2}$/.test(e) ? i.runCountDown($(this), e, 1) : /^\d{1,2}:\d{2}:\d{2}:\d{2}$/.test(e) && (t = $(this).data("product-id"), i.initReverseCountdown($(this), e, t)))
        })
    },
    destroyDealCountdown: function(t) {
        "string" == typeof t && (t = $(t)), 0 < t.find(this.selectors.productGroup.countdown).length && t.find(this.selectors.productGroup.countdown).each(function() {
            $(this).countdown("stop")
        })
    },
    runReLoadReview: function(t, e) {
        if (theme.review.enable)
            if ("string" == typeof t && (t = $(t)), "product_review" == theme.review.app) {
                if ("undefined" != typeof SPR && void 0 !== SPR.$) {
                    if (!e) return SPR.initDomEls(), SPR.loadBadges();
                    SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges()
                }
            } else "yotpo" == theme.review.app && new Yotpo.API(yotpo).refreshWidgets()
    },
    reLoadReview: function(t) {
        this.runReLoadReview(t, !1)
    },
    runProgressBar: function(t) {
        0 < t.length && t.width(t.data("width") + "%")
    },
    initQuickView: function() {
        var a = this,
            s = this.selectors.qvPopup,
            n = this.selectors.workingClass;
        $(document).on("click", this.selectors.qvBtn, function(t) {
            var e, o;
            t.preventDefault(), $(this).hasClass(n) || ($(this).addClass(n), e = $(this).attr("href"), "tooltip" == (o = $(this)).attr("data-toggle") && o.tooltip("hide"), a.startLoadingBtn(o), a.loadCssJsLib("quickViewPopup"), a.callAjax(e, "GET", {
                view: "quick_view"
            }, null, function(t) {
                var e = $(".product-single-json", t);
                0 < e.length && (a.data.productGroup[e.attr("data-handle")] = $.parseJSON(e.html()), a.addProductRecentView(e.attr("data-handle")));
                var i = $(s).find(".product-section-content");
                i.html(a.stripScripts($(".section-product-main", t).html())), 0 < $(".model-json", t).length && i.append($(".model-json", t)), a.showPopup(s), a.convertCurrencySilence(s + " span.money"), a.applyCustomColorSwatches(s), a.endLoadingBtn(o), a.rteWrap(s + " .rte"), o.removeClass(n), a.reLoadReview(s), a.runProgressBar($(s + " .progress-bar")), a.popularAddedWishlistItems(s)

//                 var prd_id = e.attr("data-product-id");
//                 prd_id = 6640171679992;
//                  const config = {
//                   productId: prd_id , // Required
//                   injectionParent: 'form[action*="cart/add"]', // The node that will have the widget injected in
//                   injectionMethod: 'prepend', // How will the widget be injected 
//                   injectFn: (node, target) => {} // Runs a custom injection function 
                  
//                 };
//                 console.log(prd_id);
               
//                 window.ReChargeWidget.createWidget(config);

               
            }))
        }), $(document).on("show.bs.modal", s, function() {
            a.loadCssJsLib("product-global", function() {
                a.init3dModel($(s), $(s + " .model-json").attr("id").replace("ModelJson-", "")), setTimeout(function() {
                    a.initProductThumbsSlider(s), a.initProductMainSliderAndZoom(s, 0, 0)
                }, 500)
            }), a.initDealCountdown(s)
        }), $(document).on("hidden.bs.modal", s, function() {
            a.destroyProductMainSliderAndZoom(s), a.destroyProductThumbsSlider(s), a.destroyDealCountdown(s)
        })
    },
    initSelectOption: function() {
        var o = this,
            a = this.selectors.selectOptionPopup,
            s = this.selectors.workingClass;
        $(document).on("click", this.selectors.selectOptionBtn, function(t) {
            var e, i;
            t.preventDefault(), $(this).hasClass(s) || ($(this).addClass(s), e = $(this).attr("href"), i = $(this), o.startLoadingBtn(i), o.loadSnippetAjax("popup-select-option", function() {
                o.callAjax(e, "GET", {
                    view: "select_option"
                }, null, function(t) {
                    var e = $(".product-single-json", t);
                    0 < e.length && (o.data.productGroup[e.attr("data-handle")] = $.parseJSON(e.html())), $(a).find(".product-section-content").html(o.stripScripts(t)), o.convertCurrencySilence(a + " span.money"), o.applyCustomColorSwatches(a), o.endLoadingBtn(i), o.showPopup(a), i.removeClass(s)
                })
            }))
        })
    },
    getCookieItemsValue: function(t, e) {
        var i;
        return void 0 === this.data.cookieArray[e] && (i = this.getCookie(e), this.data.cookieArray[e] = null == i || "" == i ? [] : i.split(",")), t ? this.data.cookieArray[e] : this.data.cookieArray[e].join(",")
    },
    isProductExistInCookie: function(t, e) {
        return 0 <= this.getCookieItemsValue(!0, e).indexOf(t)
    },
    addProductToCookie: function(t, e) {
        var i = this.getCookieItemsValue(!0, e);
        i.indexOf(t) < 0 && (i.push(t), this.data.cookieArray[e] = i, this.setCookie(e, i.join(","), null))
    },
    removeProductFromCookie: function(t, e) {
        null != this.data.cookieArray[e] && 0 <= this.data.cookieArray[e].indexOf(t) && (this.data.cookieArray[e].splice(this.data.cookieArray[e].indexOf(t), 1), this.setCookie(e, this.data.cookieArray[e].join(","), null))
    },
    loadCompare: function(i) {
        var o = this;
        this.loadCssJsLib("quickViewPopup"), this.callAjax(theme.rootUrl, "GET", {
            view: "compare",
            q: o.getCookieItemsValue(!1, o.options.compare.cookieName)
        }, null, function(e) {
            o.loadSnippetAjax("popup-compare", function() {
                var t = $(o.selectors.compare.popup).find(".compare-content");
                t.html(o.stripScripts(e)), o.rteWrap(o.selectors.compare.popup + " .rte"), o.applyCustomColorSwatches(t), o.convertCurrencySilence(t.find("span.money")), o.findBestPriceInCompare(), o.reLoadReview(t), o.firstLoaded = !0, i && i()
            })
        })
    },
    findBestPriceInCompare: function() {
        var o = this.selectors.compare,
            a = this,
            t = $(o.bestPriceBadge),
            s = -1,
            n = 0,
            r = $(o.popup);
        0 < t.length && (t.each(function() {
            var t = $(this).parents("td").attr("data-index"),
                e = !r.find('td[data-index="' + t + '"]' + o.availabilityRow + " " + a.selectors.productGroup.stockText).hasClass("soldout"),
                i = parseFloat($(this).attr("data-price"));
            e && (0 == n || i < n) && (n = i, s = $(this).parents("td").attr("data-index"))
        }), t.addClass("hide"), $(o.popup + ' td[data-index="' + s + '"] ' + o.bestPriceBadge).removeClass("hide"))
    },
    afterUpdatedVariantCompare: function(t) {
        var e, i, o, a, s, n, r = this.selectors.productGroup,
            l = t.attr("data-index"),
            d = t.parents(r.wrap),
            c = t.parents("table"),
            u = t.val(),
            p = this.data.productGroup[d.attr("data-product-handle")];
        null == p || null != (e = p[u]) && ((i = c.find('td[data-index="' + l + '"] ' + r.price)).html(this.getVariantPriceHtml(d, e)), this.convertCurrencySilence(i.find("span.money")), i.parent().find(this.selectors.compare.bestPriceBadge).attr("data-price", e.price), null != e.featured_media && null != e.featured_media.src && ((o = c.find('td[data-index="' + l + '"] ' + r.mainImg)).parent(":not(.not-loading)").addClass("loading"), o.attr("data-src", this.resizeImage(e.featured_media.src, o.attr("data-image-size")).replace("_1x1.", "_{width}x.")), o.addClass("lazyload")), a = c.find('td[data-index="' + l + '"]' + this.selectors.compare.actionsRow), s = c.find('td[data-index="' + l + '"]' + this.selectors.compare.availabilityRow), n = a.find(this.selectors.cart.addBtn), e.available ? (n.removeAttr("disabled"), n.removeClass("soldout"), n.attr("title", theme.strings.addToCart).tooltip("fixTitle"), n.find("span").text(theme.strings.addToCart), s.find(r.stockText).text(theme.strings.instockText).removeClass("soldout")) : (n.attr("disabled", "disabled"), n.addClass("soldout"), n.attr("title", theme.strings.soldOut).tooltip("fixTitle"), n.find("span").text(theme.strings.soldOut), s.find(r.stockText).text(theme.strings.soldOut).addClass("soldout")), a.find(r.variantId).val(u), this.findBestPriceInCompare())
    },
    initCompareEvent: function() {
        var o = this,
            i = "working",
            a = this.selectors.compare,
            s = this.options.compare.cookieName;
        $(a.number).text(this.getCookieItemsValue(!0, s).length), $(document).on("click", a.btn, function(t) {
            t.preventDefault();
            var e = $(this).attr("data-handle"),
                i = $(this);
            "tooltip" == i.attr("data-toggle") && i.tooltip("hide"), o.isProductExistInCookie(e, s) && 0 < $(o.selectors.compare.popup).find("table").length ? o.showPopup(o.selectors.compare.popup) : (o.addProductToCookie(e, s), $(a.number).text(o.getCookieItemsValue(!0, s).length), o.startLoadingBtn(i), o.loadCompare(function() {
                o.endLoadingBtn(i), o.showPopup(o.selectors.compare.popup)
            }))
        }), $(document).on("click", a.removeBtn, function(t) {
            t.preventDefault();
            var e = $(this).attr("data-handle");
            o.removeProductFromCookie(e, s), $(a.number).text(o.getCookieItemsValue(!0, s).length), o.loadCompare()
        }), $(document).on("click", a.headerLink, function(t) {
            t.preventDefault();
            var e = $(this);
            e.hasClass(i) || (e.addClass(i), o.firstLoaded ? (o.showPopup(o.selectors.compare.popup), e.removeClass(i)) : (o.showLoadingFull(), o.loadCompare(function() {
                o.hideLoadingFull(), o.showPopup(o.selectors.compare.popup), e.removeClass(i)
            })))
        }), $(document).on("change", a.variantId, function(t) {
            o.afterUpdatedVariantCompare($(this))
        })
    },
    loadDynamicProductsAjax: function(t, e, i) {
        var o = {
            view: "dynamic_ajax",
            q: t,
            page: e
        };
        this.callAjax(theme.rootUrl, "GET", o, null, i)
    },
    addProductMetaData: function(t, e) {
        e && (this.convertCurrencySilence(t.find("span.money")), this.reLoadReview(t)), this.initDealCountdown(t), this.applyCustomColorSwatches(t), this.popularAddedWishlistItems(t)
    },
    afterLoadDynamicProductsAjaxInTab: function(t, e) {
        t.removeClass(this.selectors.waitingData.replace(".", "")), t.append($(".products", e).html());
        var i = t.siblings(this.selectors.loadMoreBtn);
        0 < i.length && i.remove(), 0 < $(this.selectors.loadMoreBtn, e).length && t.parent().append($(this.selectors.loadMoreBtn, e).get(0).outerHTML)
    },
    destroyInfiniteScroll: function(t) {
        void 0 !== this.data.productGroupInfiniteScroll[t] && $.each(this.data.productGroupInfiniteScroll[t], function(t, e) {
            e.destroy()
        })
    },
    initInfiniteScroll: function(t) {
        var o;
        "string" == typeof t && (t = $(t)), 0 < t.find(this.selectors.infiniteScroll.button).length && (o = this).loadCssJsLib("waypoint", function() {
            o.loadCssJsLib("infinite", function() {
                t.find(o.selectors.infiniteScroll.button).each(function() {
                    var t = $(this).attr("data-id-save");
                    void 0 === o.data.productGroupInfiniteScroll[t] && (o.data.productGroupInfiniteScroll[t] = []);
                    var e = $(this).siblings(".products").first(),
                        i = $(this).attr("data-id");
                    o.data.productGroupInfiniteScroll[t].push(new Waypoint.Infinite({
                        element: e,
                        items: ".grid__item",
                        more: i,
                        onAfterPageLoad: function(t) {
                            o.applyCustomColorSwatches(t), BtCurrency.convertSilence(shopCurrency, BtCurrency.currentCurrency, t.find("span.money")), o.initDealCountdown(t), o.reLoadReview(t)
                        }
                    }))
                })
            })
        })
    },
    invertColor: function(t, e) {
        if (0 === t.indexOf("#") && (t = t.slice(1)), 3 === t.length && (t = t[0] + t[0] + t[1] + t[1] + t[2] + t[2]), 6 !== t.length) return !1;
        var i = parseInt(t.slice(0, 2), 16),
            o = parseInt(t.slice(2, 4), 16),
            a = parseInt(t.slice(4, 6), 16);
        return e ? 186 < .299 * i + .587 * o + .114 * a ? "#000000" : "#FFFFFF" : (i = (255 - i).toString(16), o = (255 - o).toString(16), a = (255 - a).toString(16), "#" + this.padZero(i) + this.padZero(o) + this.padZero(a))
    },
    padZero: function(t, e) {
        return e = e || 2, (new Array(e).join("0") + t).slice(-e)
    },
    loadCustomColorCodes: function(e) {
        var i;
        null != this.data.customColorCodes || this.data.customColorCodesLoading ? e() : 0 == this.data.customColorCodesLoading && ((i = this).data.customColorCodesLoading = !0, this.callAjax(theme.rootUrl, "GET", {
            view: "color_codes"
        }, null, function(t) {
            i.data.customColorCodes = $.parseJSON(t.replace("\x3c!-- BEGIN template --\x3e\x3c!-- index.color_codes --\x3e", "").replace("\x3c!-- END template --\x3e", "")), i.data.customColorCodesLoading = !1, 0 < i.data.customColorCodesStack.length && $.each(i.data.customColorCodesStack, function(t, e) {
                i.runCustomColorCodes(e), delete i.data.customColorCodesStack[t]
            }), e()
        }))
    },
    runCustomColorCodes: function(t) {
        "string" == typeof t && (t = $(t));
        var a = this;
        t.find(".color-load:not(.color-loaded)").each(function() {
            var t, e, i, o = $(this).attr("data-color-tag");
            null == o || null != (t = a.data.customColorCodes[o]) && (null != t.color && ($(this).css("background-color", t.color), $(this).hasClass("ignore-color-text") || (e = a.invertColor(t.color, !0)) && $(this).css("color", e)), null != t.image && (i = a.resizeImage(t.image, "46x46_crop_center"), $(this).css("background-image", "url(" + i + ")"))), $(this).addClass("color-loaded")
        })
    },
    applyCustomColorSwatches: function(t) {
        var e = this;
        this.loadCustomColorCodes(function() {
            e.data.customColorCodesLoading ? e.data.customColorCodesStack.push(t) : e.runCustomColorCodes(t)
        })
    },
    initLoadMoreBtn: function() {
        var a = this;
        $(document).on("click", this.selectors.loadMoreBtn, function(t) {
            t.preventDefault();
            var e, i, o = $(this);
            o.hasClass(a.selectors.workingClass) || (o.addClass(a.selectors.workingClass).prepend('<i class="' + a.selectors.loadingAjaxClass + '" style="margin-right: 5px;"></i>'), e = $(this).attr("data-href"), i = $(this).siblings(".grid"), null == e ? a.loadDynamicProductsAjax($(this).attr("data-ajax-params"), 2, function(t) {
                a.afterLoadDynamicProductsAjaxInTab(i, t), a.addProductMetaData(i, !0)
            }) : a.callAjax(e, "GET", null, null, function(t) {
                a.afterLoadDynamicProductsAjaxInTab(i, t), a.addProductMetaData(i, !0)
            }))
        })
    },
    updateThresholdMenu: function(t) {
        this.data.thresholdMenu += t
    },
    calculateThresholdAndFixSticker: function() {
        var t = this.data.stickyMenuObj.outerHeight();
        this.data.thresholdMenu = this.data.stickyMenuObj.offset().top + t, this.fixedHeightSticker(t)
    },
    updateStickyMenuObj: function(t) {
        t.hasClass("use-sticky") ? this.data.stickyMenuObj = t : this.data.stickyMenuObj = t.parents(".use-sticky").first()
    },
    openStickyMenu: function() {
        $(window).scrollTop() > this.data.thresholdMenu ? this.data.stickyMenuObj.hasClass("active") || this.data.stickyMenuObj.addClass("active") : this.hideStickyMenu()
    },
    hideStickyMenu: function() {
        this.data.stickyMenuObj.hasClass("active") && !$("body").hasClass("open-search-suggest") && this.data.stickyMenuObj.removeClass("active")
    },
    fixedHeightSticker: function(t) {
        this.data.sticker.height(t)
    },
    initStickyMenu: function() {
        var i;
        $(".use-sticky").length ? (i = this, $(".use-sticky--desktop"), i.data.cacheWindowWidth < 992 && $(".use-sticky--mobile"), this.data.sticker = $(".header-sticker"), this.data.stickyMenuObj = $(".header-sticker__inner"), this.calculateThresholdAndFixSticker(), this.initPromotion(), $(window).on(this.data.scrollEventName, function(t, e) {
            i.data.pageLoaded && 0 == i.data.updatingProductOptions && ("down" == e && 0 == i.data.openingDesktopNav ? i.hideStickyMenu() : i.openStickyMenu())
        }), $(window).on(this.data.resizeEventName, function(t) {
            i.calculateThresholdAndFixSticker()
        })) : this.initPromotion()
    },
    initRecommendedProducts: function() {
        theme.enableRecommendedProducts && setTimeout(function() {
            var t = this.options.rp.cookieName;
            null == this.getCookie(t) && this.loadCssJsLib("recommendedProducts")
        }.bind(this), 8e3)
    },
    initNewsTerms: function(t) {
        var e, i, o, a, s, n;
        theme.newsTerms && (e = $(t + " " + this.selectors.newsTerms.form), i = $(t + " " + this.selectors.newsTerms.input), o = $(t + " " + this.selectors.newsTerms.error), a = this.options.newsTerms.cookieName, s = this.getCookie(a), n = this, e.unbind("submit"), i.unbind("change"), "1" == s && i.attr("checked", "checked"), i.on("change", function() {
            $(this).is(":checked") ? (n.setCookie(a, 1), o.hasClass("working") && (o.fadeOut(), o.removeClass("working"))) : n.setCookie(a, 0)
        }), e.on("submit", function(t) {
            i.is(":checked") || (t.preventDefault(), o.fadeIn(), o.addClass("working"))
        }))
    },
    initNewsletterPopup: function() {
        theme.enableNewsPopup && "newsletter-popup-form" != location.hash.substr(1) && setTimeout(function() {
            $("body").hasClass("modal-open") || $("body").hasClass("open-search-suggest") || this.loadCssJsLib("newsletterPopup")
        }.bind(this), 8e3)
    },
    initPromotion: function() {
        var e, t, i, o = this.selectors.promo,
            a = this;
        0 < $(o.wrap).length && (e = this.options.promo.cookieName, t = this.getCookie(e), i = 0 < $(".use-sticky").length, null != t && null != t && "null" != t || $(o.wrap).slideDown(300, function() {
            i && (992 <= a.data.cacheWindowWidth ? a.updateThresholdMenu($(o.wrap).outerHeight()) : a.updateThresholdMenu(a.data.thresholdMenuWithPromotion)), $(o.list).addClass("run"), $(o.wrap).removeClass("close")
        }), $(document).on("click touchend", o.closeBtn, function(t) {
            t.preventDefault(), $(o.wrap).slideUp(300, function() {
                i && (992 <= a.data.cacheWindowWidth ? a.updateThresholdMenu(-1 * $(o.wrap).outerHeight()) : a.updateThresholdMenu(-1 * a.data.thresholdMenuWithPromotion)), $(o.list).removeClass("run"), $(o.wrap).addClass("close")
            }), a.setCookie(e, 1, 1)
        }))
    },
    initBackTopButton: function() {
        $("#back-top").length && $(document).on("click touchend", "#back-top a", function() {
            return $("body,html").animate({
                scrollTop: 0
            }, 800), !1
        })
    },
    initCookieConsent: function() {
        var i;
        theme.enableCookieConsent && (i = this, setTimeout(function() {
            var e = "cookie_consent";
            null == i.getCookie(e) && i.loadSnippetAjax("cookie-consent", function() {
                0 < $(".cookie_consent").length && ($(".cookie_consent").slideDown(300), $(document).on("click", ".cookie_consent__close", function(t) {
                    t.preventDefault(), i.setCookie(e, 1, 365), $(".cookie_consent").slideUp(300)
                }))
            })
        }, 9e3))
    },
    initPopupVideo: function() {
        var o = this,
            a = this.selectors.popupVideo;
        $(document).on("click", a.btn, function(t) {
            var i;
            t.preventDefault(), o.data.modalVideoWorking || (i = $(this), new Promise(function(t, e) {
                o.data.modalVideoWorking = !0, -1 < theme.loadedLibs.indexOf("modalvideo") ? t(i) : o.loadCssJsLib("modalvideo", function() {
                    $(a.youtubeBtn).modalVideo(), $(a.vimeoBtn).modalVideo({
                        channel: "vimeo"
                    }), t(i)
                })
            }).then(function(t) {
                o.data.modalVideoWorking = !1;
                var e = t.attr("data-video-id");
                "youtube" == t.attr("data-video-type") ? ($(a.youtubeBtn).attr("data-video-id", e), $(a.youtubeBtn).trigger("click")) : ($(a.vimeoBtn).attr("data-video-id", e), $(a.vimeoBtn).trigger("click"))
            }, function(t) {}))
        })
    },
    loadWishlist: function(i) {
        var o = this,
            a = this.selectors.wishlist,
            t = this.options.wishlist.cookieName,
            e = this.getCookieItemsValue(!1, t);
        "" == e || null == e ? this.loadSnippetAjax("popup-wishlist", function() {
            var t = $(a.popup).find(".content");
            o.appendWishlistEmtptyStr(t), o.data.wishlist.loaded = !0, i && i()
        }) : this.callAjax(theme.rootUrl, "GET", {
            view: "wishlist",
            q: e
        }, null, function(e) {
            o.loadSnippetAjax("popup-wishlist", function() {
                var t = $(a.popup).find(".content");
                t.html(o.stripScripts(e)), t.hasClass("grid") || t.addClass("grid grid--medium"), o.applyCustomColorSwatches(t), o.convertCurrencySilence(t.find("span.money")), o.reLoadReview(t), o.data.wishlist.loaded = !0, i && i()
            })
        })
    },
    popularAddedWishlistItems: function(t) {
        var i, e, o, a, s;
        theme.enableWishlist && ("string" == typeof t && (t = $(t)), i = this.selectors.wishlist, e = this.options.wishlist.cookieName, a = o = "", 0 < (s = this.getCookieItemsValue(!0, e)).length && $.each(s, function(t, e) {
            "" != o && (o += ",", a += ","), o += i.btn + '[data-handle="' + e + '"]', a += i.btnWithText + '[data-handle="' + e + '"] ' + i.btnText
        }), t.find(o).addClass("added").attr("title", theme.strings.addedWishlistTitle), t.find(a).text(theme.strings.addedWishlistTitle))
    },
    appendWishlistEmtptyStr: function(t) {
        t.removeClass("grid grid--medium"), t.html('<div class="alert alert-danger"><span>' + theme.strings.wishlistEmpty + "</span></div>")
    },
    initWishlist: function() {
        var o, a, s, t, i;
        theme.enableWishlist && (o = this.selectors.wishlist, a = this.options.wishlist.cookieName, t = (s = this).getCookieItemsValue(!0, a), i = "working", this.popularAddedWishlistItems("body"), $(o.number).text(t.length), $(document).on("click", o.btn, function(t) {
            t.preventDefault();
            var e = $(this).attr("data-handle");
            $(this);
            s.isProductExistInCookie(e, a) ? (s.removeProductFromCookie(e, a), $(o.btn + '[data-handle="' + e + '"]').removeClass("added").attr("title", theme.strings.addWishlistTitle), $(o.btnWithText + '[data-handle="' + e + '"] ' + o.btnText).text(theme.strings.addWishlistTitle)) : (s.addProductToCookie(e, a), $(o.btn + '[data-handle="' + e + '"]').addClass("added").attr("title", theme.strings.addedWishlistTitle), $(o.btnWithText + '[data-handle="' + e + '"] ' + o.btnText).text(theme.strings.addedWishlistTitle)), $(o.btn + '[data-handle="' + e + '"][data-toggle="tooltip"]').tooltip("fixTitle"), "tooltip" == $(this).attr("data-toggle") && $(this).tooltip("show"), $(o.number).text(s.getCookieItemsValue(!0, a).length), s.data.wishlist.loaded = !1, $(o.headerLink + " i").addClass(s.selectors.ringClass)
        }), $(document).on("click", o.removeBtn, function(t) {
            t.preventDefault();
            var e, i = $(this).attr("data-handle");
            s.removeProductFromCookie(i, a), $(o.number).text(s.getCookieItemsValue(!0, a).length), $(o.btn + '[data-handle="' + i + '"]').removeClass("added").attr("title", theme.strings.addWishlistTitle), $(o.btn + '[data-handle="' + i + '"][data-toggle="tooltip"]').tooltip("fixTitle"), $(o.btnWithText + '[data-handle="' + i + '"] ' + o.btnText).text(theme.strings.addWishlistTitle), "tooltip" == $(this).attr("data-toggle") && $(this).tooltip("hide"), $(o.popup + ' .item[data-product-handle="' + i + '"]').remove(), 0 == $(o.popup).find(".item").length && (e = $(o.popup).find(".content"), s.appendWishlistEmtptyStr(e))
        }), $(document).on("click", o.headerLink, function(t) {
            t.preventDefault();
            var e = $(this);
            e.hasClass(i) || (e.addClass(i), s.data.wishlist.loaded ? (s.showPopup(o.popup), e.removeClass(i)) : (s.showLoadingFull(), s.loadWishlist(function() {
                s.hideLoadingFull(), s.showPopup(o.popup), e.removeClass(i)
            })))
        }))
    },
    initExpandTrigger: function() {
        var o = "working";
        $(document).on("click touchend", ".expand-trigger", function(t) {
            var e, i;
            t.preventDefault(), $(this).hasClass("working") || ((e = $(this)).addClass("working"), i = "slideDown", e.hasClass("open") && (i = "slideUp"), e.toggleClass("open"), "slideDown" == i ? e.siblings(".expand-content").slideDown(300, function() {
                e.removeClass(o)
            }) : e.siblings(".expand-content").slideUp(300, function() {
                e.removeClass(o)
            }))
        })
    },
    initResizeWindowTrigger: function() {
        this.data.cacheWindowWidth = $(window).width();
        var i = this;
        $(window).resize($.debounce(250, function(t) {
            var e = $(window).width();
            i.data.cacheWindowWidth !== e && (i.data.cacheWindowWidth = $(window).width(), $(window).trigger(i.data.resizeEventName))
        }))
    },
    initScrollingWindow: function() {
        var i = 0,
            o = this;
        $(window).scroll($.throttle(100, function(t) {
            var e = window.pageYOffset || document.documentElement.scrollTop;
            i < e ? $(window).trigger(o.data.scrollEventName, ["down"]) : $(window).trigger(o.data.scrollEventName, ["up"]), i = e <= 0 ? 0 : e
        })), $(window).on(this.data.resizeEventName, function(t) {
            var e = window.pageYOffset || document.documentElement.scrollTop;
            i = e <= 0 ? 0 : e
        })
    },
    initScrollingWindowTriggerOnce: function(t, e, i, o) {
        i = null != i ? i : 0;
        var a, s, n, r = t.offset().top + i;
        window.pageYOffset + window.innerHeight > r ? o() : (a = !1, s = "scroll." + e, n = this.data.resizeEventName + ".scroll_" + e, $(window).on(s, $.throttle(250, function(t) {
            window.pageYOffset + window.innerHeight > r && ($(window).off(s), $(window).off(n), a || (a = !0, o()))
        })), $(window).on(n, function() {
            a ? $(window).off(n) : setTimeout(function() {
                r = t.offset().top + i, window.pageYOffset + window.innerHeight > r && ($(window).off(s), $(window).off(n), a || (a = !0, o()))
            }, 300)
        }))
    },
    destroyScrollingWindowTriggerOnce: function(t) {
        $(window).off("scroll." + t), $(window).off(this.data.resizeEventName + ".scroll_" + t)
    },
    renderColumnsAjaxLoading: function(t, e) {
        for (var i = "", o = 0; o < e; o++) i += '<div class="pcol__item item dib w100 gutter-ele-bottom"><div class="flex flex-wrap flex-align-space-between"><div class="pcol__item__left col-xs-4 no-gutter--left"><div class="item__image img-container loading" style="padding-top:130%;"></div></div><div class="pcol__item__right col-xs-8 no-gutter"><span class="db w100 loading" style="height:20px;"></span><div class="gutter-ele-top"><span class="db w100 loading" style="height:20px;"></span></div><div class="gutter-ele-top"><span class="db w100 loading" style="height:20px;"></span></div></div></div></div>';
        t.html(i)
    },
    loadProductColumnsAjax: function(i) {
        var o = "working",
            a = this;
        i.hasClass("load-product-columns-ajax") && this.loadCssJsLib("waypoint", function() {
            var e = i.waypoint(function(t) {
                i.hasClass(o) || (e[0].destroy(), i.addClass(o), i.find(".pcol__items").each(function() {
                    a.renderColumnsAjaxLoading($(this), parseInt($(this).attr("data-limit")))
                }), a.renderSectionByAjaxApi(i.attr("data-section-id"), {}, function(t) {
                    i.find(".pcol__items").each(function() {
                        $(this).html($("#" + $(this).attr("id"), t).html()), $(this).removeClass("waiting-data")
                    }), a.addProductMetaData(i, !0), a.initSlider(i, !1, !1)
                }))
            }, {
                triggerOnce: !0,
                offset: "100%"
            })
        })
    },
    addProductRecentView: function(t) {
        theme.enableRecentView && this.addProductToCookie(t, this.options.recentView.cookieName)
    },
    updateCart:function (){
    $.ajax({
      url: "/cart.js",
      type: 'GET',
      dataType: 'json', // added data type
      success: function(cart) {
        console.log(cart);
        var itemcount = cart.item_count;
        $(".cart-number").text(itemcount);
        //$(document).find('.cart_count').text(itemcount);
        //localStorage.setItem("quiz_cart", 1);
        //location.reload();
        BT.updateHeaderCartHtml(!1); 
        setTimeout(function() {
            $(".cart-sidebar-trigger").trigger("click");
        }, 300);
        
      }
    });
  },
  addTocart: function(v,q){
    
    //alert(v);
    return $.ajax({
      url: "/cart/add.js",
      type: 'POST',
      data:{id:v,quantity:q},
      dataType: 'json', // added data type
      success: function(res) {
        $('body').removeClass('loading');
        BT.updateCart();
      }
    });
  },
  loadRequireCss: function() {
        var i;
        0 < theme.requireCss.length && (i = this, $(theme.requireCss).each(function(t, e) {
            i.loadCssJsLib(e)
        }))
    },
    initRingAnimation: function() {
        var t = this;
        $(document).on("webkitAnimationEnd oanimationend msAnimationEnd animationend", ".ring-animation", function() {
            $(this).removeClass(t.selectors.ringClass)
        })
    },
    initProductCustomFields: function() {
        $(document).on("change", ".pg__field__ele", function() {
            var t, e = $($(this).attr("data-target"));
            e.hasClass("pg__field__group-checkbox") ? (t = [], $(this).parents(".pg__field").find(".pg__field__ele").each(function() {
                $(this).is(":checked") && t.push($(this).val())
            }), e.val(t.join(", "))) : $(this).is(":checked") ? e.prop("checked", !0) : e.prop("checked", !1), e.valid()
        }), $(document).on("click", ".pg__field__radio", function() {
            var t = $($(this).attr("data-target"));
            t.val($(this).val()), t.valid()
        })
    },
    initModalLink: function() {
        var e = this;
        $(document).on("click", ".modal-link", function(t) {
            t.preventDefault(), e.showPopup($(this).attr("data-target"))
        })
    },
    init: function() {
        this.initFloatField(), this.initMobileNavigation(), this.initSearchSuggestion(), this.initResizeWindowTrigger(), this.initScrollingWindow(), this.initDropdown(), this.initProductGroup(), this.initCartEvent(), this.initQtyBox(), this.refreshSliderInTabs(), this.initQuickView(), this.initSelectOption(), this.initCompareEvent(), this.initWishlist(), this.initLoadMoreBtn(), this.initRecommendedProducts(), this.initNewsletterPopup(), this.initCookieConsent(), this.initExpandTrigger(), this.initOverlay(), this.initModalLink(), this.rteWrap("body .rte"), $("body").tooltip({
            selector: '[data-toggle="tooltip"]',
            trigger: "hover",
            container: "body"
        }), setTimeout(function() {
            this.updateFaviconBadge(theme.cartNumber), this.initBackTopButton(), this.initAgreeCartTems(), this.initPopupVideo(), this.initProductCustomFields()
        }.bind(this), 500), theme.disableCopy && document.addEventListener("contextmenu", function(t) {
            t.preventDefault()
        }), $(document).one("touchstart", function() {
            this.data.isTouchDevide = !0
        }.bind(this)), BT.detectAutoFields(), BT.initSidebar(), setTimeout(function() {
            BT.data.pageLoaded = !0, BT.initRingAnimation(), BT.initStickyMenu()
        }, 500)
        
        $(document).on('click','.btn-custom.btn-add-to-cart',function(e){
          e.preventDefault();
          var id = $(this).attr('data-variant'),
              quantity = 1;
          $('body').addClass('loading');
          var id = BT.addTocart(id,quantity);
          //console.log(id);
        });

        $("#CustomerEmail").on("keyup change", function(e) {
            $(this).parent().addClass("active focus")
        });
      
        $(document).on('click','.btn-result-bundle-products',function(){
            var tr = $(document).find('.quiz-results ul.result-recommended>li').length-1;
            $('body').addClass('loading');

            setTimeout(function(){
              $(document).find('.quiz-results ul.result-recommended>li').each(function(i,item){
                var id = $(this).find('.btn-add-to-cart').attr('data-variant');
                if(id !== undefined){
                  console.log(i +'  '+tr );
                 // console.log(id);
                  $.ajax({
                    url: "/cart/add.js",
                    type: 'POST',
                    data:{id:id,quantity:1},
                    dataType: 'json', // added data type
                    async:false,
                    success: function(res) {
                      if(i == tr){
                        $('body').removeClass('loading');
                       // window.location.href="/cart";
                        var itemcount = res.item_count;
                        $(".cart-number").text(itemcount);
                       // $(document).find('.cart_count').text(itemcount);
                        BT.updateHeaderCartHtml(!1); 
                          setTimeout(function() {
                              $(".cart-sidebar-trigger").trigger("click");
                          }, 300);
                      }
                    },
                    error:function(){
                      if(i == tr){
                        //$('body').removeClass('loading');
                        //window.location.href="/cart";
                      }
                    }
                  });
                }
              });
            },500)
          });
    }
    
  
    
};